import { c as _c } from "react/compiler-runtime";
import { IcoPlusSmall24 } from '@onefootprint/icons';
import type { HostedBusinessOwner } from '@onefootprint/request-types';
import { LinkButton, Tooltip } from '@onefootprint/ui';
import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { ManageBosFormData } from '../manage-business-owners.types';
import { sumTotalOwnershipStake } from '../utils/manage-bos-utils';
type AddBoButtonProps = {
  existingBos: HostedBusinessOwner[];
  onAdd: () => void;
};

/** Isolated component that watches ownership stake to prevent parent re-renders during form input */
export const AddBoButton = t0 => {
  const $ = _c(21);
  const {
    existingBos,
    onAdd
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectBusinessData.beneficialOwners.form"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const {
    control
  } = useFormContext();
  let t2;
  if ($[1] !== control) {
    t2 = {
      control,
      name: "bos"
    };
    $[1] = control;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const watchedBos = useWatch(t2);
  let t3;
  if ($[3] !== control) {
    t3 = {
      control,
      name: "bosToDelete"
    };
    $[3] = control;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const watchedBosToDelete = useWatch(t3);
  let t4;
  if ($[5] !== existingBos || $[6] !== watchedBos || $[7] !== watchedBosToDelete) {
    const bos = watchedBos || [];
    const bosToDelete = watchedBosToDelete || [];
    t4 = sumTotalOwnershipStake(existingBos, {
      bos,
      bosToDelete
    });
    $[5] = existingBos;
    $[6] = watchedBos;
    $[7] = watchedBosToDelete;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const totalOwnershipStake = t4;
  const isStakeInvalid = totalOwnershipStake > 100;
  const t5 = !isStakeInvalid;
  let t6;
  if ($[9] !== t) {
    t6 = t(_temp);
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t(_temp2);
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== isStakeInvalid || $[14] !== onAdd || $[15] !== t7) {
    t8 = <LinkButton data-dd-action-name="add-beneficial-owner" iconComponent={IcoPlusSmall24} iconPosition="left" variant="label-2" onClick={onAdd} disabled={isStakeInvalid}>{t7}</LinkButton>;
    $[13] = isStakeInvalid;
    $[14] = onAdd;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t5 || $[18] !== t6 || $[19] !== t8) {
    t9 = <Tooltip disabled={t5} content={t6}>{t8}</Tooltip>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
function _temp($) {
  return $["add-another-disabled-tooltip"];
}
function _temp2($_0) {
  return $_0["add-another"];
}